/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

jQuery(function ($) {
   $(document).ready(function(){


( function() {
	const siteNavigation = document.getElementById( 'site-navigation' );

	// Return early if the navigation doesn't exist.
	if ( ! siteNavigation ) {
		return;
	}

	const button = siteNavigation.getElementsByTagName( 'button' )[ 0 ];

	// Return early if the button doesn't exist.
	if ( 'undefined' === typeof button ) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName( 'ul' )[ 0 ];

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		button.style.display = 'none';
		return;
	}

	if ( ! menu.classList.contains( 'nav-menu' ) ) {
		menu.classList.add( 'nav-menu' );
	}

  // Set manu initial display to flex when screen height is small
  if ($(window).height() < 625 && $(window).width() < 576) {
    $("#primary-menu")
        .css("display", "flex")
        .hide(1);
  }

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	button.addEventListener( 'click', function() {
		siteNavigation.classList.toggle( 'toggled' );
		// $('#site-navigation').slideDown('slow');

		if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
			button.setAttribute( 'aria-expanded', 'false' );
			// $('#primary-menu').slideUp();
			$('#primary-menu').fadeOut();
      $('body').css('overflow', 'inherit');
		} else {
			button.setAttribute( 'aria-expanded', 'true' );
			// $('#primary-menu').slideDown();
			$('#primary-menu').fadeIn();
      $('body').css('overflow', 'hidden');
		}
	} );

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener( 'click', function( event ) {
		const isClickInside = siteNavigation.contains( event.target );

		if ( ! isClickInside ) {
			siteNavigation.classList.remove( 'toggled' );
			// $('#site-navigation').slideUp('slow');
			button.setAttribute( 'aria-expanded', 'false' );
      $('body').css('overflow', 'inherit');
			// $('#primary-menu').slideUp();
			if ($(window).width() < 768) {
				$('#primary-menu').fadeOut();
			}
		}
	} );

	// Get all the link elements within the menu.
	const links = menu.getElementsByTagName( 'a' );

	// Get all the link elements with children within the menu.
	const linksWithChildren = menu.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

}() );

  });
});
